__turbopack_context__.v({
  "TrendingProducts": "TrendingProducts-module__iUe8Ba__TrendingProducts",
  "banner": "TrendingProducts-module__iUe8Ba__banner",
  "button": "TrendingProducts-module__iUe8Ba__button",
  "buttons": "TrendingProducts-module__iUe8Ba__buttons",
  "header": "TrendingProducts-module__iUe8Ba__header",
  "icon": "TrendingProducts-module__iUe8Ba__icon",
  "left": "TrendingProducts-module__iUe8Ba__left",
  "products": "TrendingProducts-module__iUe8Ba__products",
  "right": "TrendingProducts-module__iUe8Ba__right",
  "slider": "TrendingProducts-module__iUe8Ba__slider",
  "swiper": "TrendingProducts-module__iUe8Ba__swiper",
  "title": "TrendingProducts-module__iUe8Ba__title",
});
